import React from 'react'

export default function SkillBar ({name, percent}) {
  return (
    <div className="Skill">
      <h6 className="Title">{name}</h6>
      <div className="BarGraph">
        <p className="SkillPercentage-Number">
          {`${percent}%`}
        </p>
        <div className="SkillPercentage-Visual-Container">
          <p className="SkillPercentage-Visual" style={{width: `${percent}%`}}></p>
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/SkillBar.js